import { useState, useEffect, useCallback, useRef } from 'react';
import { toast } from 'react-toastify';
import {
  DayBar,
  CatechesisSlider,
  PlayList,
  CultureCustomsSlider,
  PrayersList,
  DayofIcon,
  LeftArrowIcon,
  FishPurpleIcon,
  HeartIcon,
  LinkIcon,
  BookOpen,
  BookIcon,
  FavoritesIcon,
} from '../components';
import interactionPlugin from '@fullcalendar/interaction';
import useLiturgicalEvents from '../hooks/useLiturgicalEvents';
import useCopyToClipboard from "../hooks/useCopyToClipboard";
import { Skeleton } from '../components/ui/skeleton';
import { Link } from 'react-router-dom';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import { fetchLiturgicalEvents } from '../utilities/api';
import { toggleFavorite, fetchDevotions, fetchRelatedLiturgicalData, fetchLiturgicalEventsByDate, fetchCultureAndCustomsListData, fetchPrayerRitesListData, fetchCatecheticalCourses } from '../utilities/api';
import { mapCultureCustomsListData, mapPrayerRitesListData, mapCatecheticalCoursesListData } from '../utilities';
// import { SingleDay } from '.';

const catechesisSection = {

  title: 'Catechesis',
  icon: <BookIcon className="text-white-50" />,
  link: '#',
  linkTitle: 'View All',
  items: [
    {
      imageUrl: `${process.env.PUBLIC_URL}/media/images/group-of-catechesis-title.jpeg`,
      title: 'Group of Catechesis title',
      openTeg: 'Recently Opened',
      catechesis: '16 Catechesis',
      aboutHours: 'About 10 hr',
      catList: ['Tradivox Shorts', 'Easter'],
      favorite: true,
    },
    {
      imageUrl: `${process.env.PUBLIC_URL}/media/images/group-of-catechesis-title.jpeg`,
      title: 'Catechesis 2',
      openTeg: 'Recently Opened',
      catechesis: '12 Catechesis',
      aboutHours: 'About 8 hr',
      catList: ['Faith', 'Learning'],
      favorite: false,
    },
    {
      imageUrl: `${process.env.PUBLIC_URL}/media/images/group-of-catechesis-title.jpeg`,
      title: 'Catechesis 2',
      openTeg: 'Recently Opened',
      catechesis: '12 Catechesis',
      aboutHours: 'About 8 hr',
      catList: ['Faith', 'Learning'],
      favorite: false,
    },
  ],
};

const views = {
  multiMonthFourMonth: {
    type: 'multiMonth',
    duration: { months: 2 }
  }
}

const events = [
  { title: 'Day', date: '2024-12-25T10:30:00', classNames: ['bda-abstinence-event'] },
  { title: 'Day 1', date: '2024-12-31', classNames: ['bda-fast-event'] },
  { title: 'Liturgical Day', date: '2024-12-27', classNames: ['bda-normal-event', 'current-day'] },
  { title: 'Liturgical Day 1', date: '2024-12-27', classNames: ['bda-abstinence-event'] },
  { title: 'event 3', date: '2024-12-28', classNames: ['bda-fast-event'] },
  { title: 'event 4', date: '2025-01-02', classNames: ['bda-fast-event'] },
  { title: 'event 7', date: '2025-01-04', classNames: ['bda-feast-event'] },
  { title: 'event 5', date: '2025-01-04', classNames: ['bda-abstinence-event'] },
  { title: 'event 8', date: '2025-01-03', classNames: ['bda-feast-event'] },
]

const staticEvents = [
  { title: 'Day', date: '2024-12-25T10:30:00', classNames: ['bda-abstinence-event'] },
  // ... rest of your static events
];

function SingleDay() {
  const calendarRef = useRef(null)
  const [isCalendarLoading, setIsCalendarLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [prevDayData, setPrevDayData] = useState({});
  const [nextDayData, setNextDayData] = useState({});
  const { copied, copyToClipboard } = useCopyToClipboard();
  const [loadingCulture, setLoadingCulture] = useState(true);
  const [singleData, setSingleData] = useState()
  const [error, setError] = useState(null);
  const [loadingPrayers, setLoadingPrayers] = useState(true);
  const [loadingCatchesis, setLoadingCatchesis] = useState(true)
  const [isLoading, setIsLoading] = useState(true)
  const [apiEvents, setApiEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAccordionVisible, setIsAccordionVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('All');
  const [isFavoriteLoading, setIsFavoriteLoading] = useState(false);
  const [recentFavorites, setRecentFavorites] = useState([])
  const [playListItems, setPlayListItems] = useState([]);
  const [loadingPlayList, setLoadingPlayList] = useState(true);
  const [cultureSliderData, setCultureSliderData] = useState({
    title: 'Explore Culture & Customs for Today',
    link: '#',
    items: [],
  });
  const [catchesisSliderData, setCatchesisSliderData] = useState({
    title: 'Learn the Faith',
    // icon: <BookIcon className="text-white-50" />,
    link: '/learn-the-faith',
    titleClass: 'text-base font-bold leading-5 text-gray-900',
    linkTitle: 'View All',
    items: [],

  });
  const [prayersData, setPrayersData] = useState({
    title: 'Prayer & Rites',
    titleClass: 'text-base font-bold leading-5 text-gray-900',
    link: '/prayer-and-rites',
    items: [],
  });

  useEffect(() => {
    const fetchAdjacentDayTitles = async () => {
      // const today = new Date();
      const date = selectedDate;

      const prevDate = new Date(date);
      prevDate.setDate(prevDate.getDate() - 1);

      const nextDate = new Date(date);
      nextDate.setDate(nextDate.getDate() + 1);

      const [prevEvents, nextEvents] = await Promise.all([
        fetchLiturgicalEventsByDate(prevDate.getFullYear(), prevDate.getMonth() + 1, prevDate.getDate()),
        fetchLiturgicalEventsByDate(nextDate.getFullYear(), nextDate.getMonth() + 1, nextDate.getDate())
      ]);

      const prevKey = Object.keys(prevEvents)?.[0];
      const nextKey = Object.keys(nextEvents)?.[0];

      const prev = prevEvents?.[prevKey];
      const next = nextEvents?.[nextKey];

      setPrevDayData({
        title: prev?.name || "Previous Day",
      });

      setNextDayData({
        title: next?.name || "Next Day",
      });
    };

    fetchAdjacentDayTitles();
  }, [selectedDate]);


  useEffect(() => {
    const calendarApi = calendarRef.current?.getApi();
    if (calendarApi) calendarApi.gotoDate(selectedDate);
  }, [selectedDate]);

  useEffect(() => {
    const loadSidebarRelatedData = async () => {
      try {
        // const today = new Date();
        // const year = today.getFullYear();
        // const month = today.getMonth() + 1;
        // const day = today.getDate();
        const date = selectedDate;
        const year = selectedDate.getFullYear();
        const month = selectedDate.getMonth() + 1;
        const day = selectedDate.getDate();


        const eventData = await fetchLiturgicalEventsByDate(year, month, day);
        const firstKey = Object.keys(eventData)?.[0];
        const postId = eventData?.[firstKey]?.eventData?.post?.ID;

        if (!postId) return;

        const related = await fetchRelatedLiturgicalData(postId);

        const cc = [];
        const pr = [];
        const ltf = [];

        related.forEach(item => {
          const type = item?.type;
          const attrs = item?.attributes || {};
          const imageUrl = attrs?.image?.large || `${process.env.PUBLIC_URL}/media/images/group-of-catechesis-title.jpeg`
          const obj = {
            id: item?.id,
            slug: attrs?.slug,
            title: attrs?.title || '',
            categories: attrs?.ps_content_type || [],
            imageUrl,
            favorite: attrs?.favorite ?? false,
          };

          if (type === 'ps-culture-customs') cc.push(obj);
          else if (type === 'ps-prayer-rites') pr.push(obj);
          else if (type === 'ps-catechesis') ltf.push(obj);
        });

        setCultureSliderData(prev => ({ ...prev, items: cc }));
        setPrayersData(prev => ({ ...prev, items: pr }));
        setCatchesisSliderData(prev => ({ ...prev, items: ltf }));
        setLoadingCulture(false);
        setLoadingPlayList(false);
      } catch (error) {
        console.error('Error loading sidebar related data for today:', error);
      }
    };

    loadSidebarRelatedData();
  }, [selectedDate]);


  const handleToggleSingleFavorite = async () => {
    if (!singleData) return;

    const currentFavorite = Boolean(singleData.favorite);
    const contentType = 'devotions'; // Or update this dynamically if needed

    try {
      setIsFavoriteLoading(true);

      // Optimistically update UI
      setSingleData((prev) => ({
        ...prev,
        favorite: !currentFavorite,
      }));

      await toggleFavorite(contentType, singleData.id, false, currentFavorite);

      toast.success(currentFavorite ? 'Removed from favorites' : 'Added to favorites');
    } catch (error) {
      console.error('Failed to toggle favorite:', error);

      // Revert UI
      setSingleData((prev) => ({
        ...prev,
        favorite: currentFavorite,
      }));

      toast.error('Failed to update favorite');
    } finally {
      setIsFavoriteLoading(false);
    }
  };
  const handleToggleFavoriteCulture = async (id) => {
    try {
      const currentFavorite = cultureSliderData.items.find(item => item.id === id)?.favorite;
      //  Optimistically update UI
      setCultureSliderData((prevData) => ({
        ...prevData,
        items: prevData.items.map(item =>
          item.id === id ? { ...item, favorite: !item.favorite } : item
        ),
      }));

      await toggleFavorite('culture-customs', id, false, currentFavorite);  //  API Call in background
    } catch (error) {
      console.error("Failed to update favorite:", error);

      //  If API call fails, revert UI
      setCultureSliderData((prevData) => ({
        ...prevData,
        items: prevData.items.map(item =>
          item.id === id ? { ...item, favorite: !item.favorite } : item
        ),
      }));
    }
  };

  // useEffect(() => {
  //   const loadCultureData = async () => {
  //     try {
  //       setLoadingCulture(true);
  //       const response = await fetchCultureAndCustomsListData(0, 3);
  //       const responseData = response.data || [];
  //       const includedData = response.included || [];

  //       const transformedData = mapCultureCustomsListData(responseData, includedData);

  //       //  Ensure `items` is always an array
  //       setCultureSliderData({
  //         title: ' Culture & Customs',
  //         link: 'culture-and-customs',
  //         items: transformedData || [], //  Ensure it's always an array
  //       });

  //     } catch (error) {
  //       console.error('Error loading culture & customs data:', error);
  //     } finally {
  //       setLoadingCulture(false);
  //     }
  //   };

  //   loadCultureData();
  // }, []);

  // //  Fetch Prayers Data from API
  // useEffect(() => {
  //   const loadPrayers = async () => {
  //     try {
  //       setLoadingPrayers(true);
  //       const response = await fetchPrayerRitesListData(0, 4);

  //       const responseData = response.data || [];
  //       const includedData = response.included || [];

  //       const transformedData = mapPrayerRitesListData(responseData, includedData);

  //       //  Ensure `items` is always an array
  //       setPrayersData({
  //         title: 'Prayer & Rites',
  //         titleClass: 'text-base font-bold leading-5 text-gray-900',
  //         // icon: <BookIcon className="text-white-50" />,
  //         link: 'prayer-and-rites',
  //         linkTitle: 'View All',
  //         items: transformedData || [],
  //       });
  //     } catch (error) {
  //       console.error('Error fetching prayers:', error);
  //     } finally {
  //       setLoadingPrayers(false);
  //     }
  //   };

  //   loadPrayers();
  // }, []);

  // //  Fetch Catchesis Data from API
  // useEffect(() => {
  //   const loadCatchesisData = async () => {
  //     try {
  //       setLoadingCatchesis(true);
  //       const response = await fetchCatecheticalCourses(0, 3);
  //       const responseData = response.data || [];
  //       const includedData = response.included || [];

  //       const transformedData = mapCatecheticalCoursesListData(responseData, includedData);

  //       //  Ensure `items` is always an array
  //       setCatchesisSliderData(prevState => ({
  //         ...prevState, // Preserve existing state if needed
  //         title: 'Learn The Faith',
  //         titleClass: 'text-base font-bold leading-5 text-gray-900',
  //         // icon: <BookIcon className="text-white-50" />, // JSX component
  //         link: '/learn-the-faith',
  //         linkTitle: 'View All',
  //         items: transformedData || [], // Ensure it's always an array
  //       }));

  //     } catch (error) {
  //       console.error('Error loading catchesis data:', error);
  //     } finally {
  //       setLoadingCatchesis(false);
  //     }
  //   };

  //   loadCatchesisData();
  // }, []);

  const handleToggleFavorite = async (id) => {
    try {
      const currentFavorite = prayersData.items.find(item => item.id === id)?.favorite;
      setPrayersData((prevData) => ({
        ...prevData,
        items: prevData.items.map(item =>
          item.id === id ? { ...item, favorite: !item.favorite } : item
        ),
      }));

      await toggleFavorite('prayer-rites', id, false, currentFavorite);  //  API Call after UI update
    } catch (error) {
      console.error("Failed to update favorite:", error);
    }
  };
  const handleToggleFavoriteCatchesis = async (id) => {
    try {
      const currentFavorite = catchesisSliderData.items.find(item => item.id === id)?.favorite;
      //  Optimistically update UI
      setCatchesisSliderData((prevData) => ({
        ...prevData,
        items: prevData.items.map(item =>
          item.id === id ? { ...item, favorite: !item.favorite } : item
        ),
      }));

      await toggleFavorite('catechetical-courses', id, true, currentFavorite); //  API Call in background
    } catch (error) {
      console.error("Failed to update favorite:", error);

      //  If API call fails, revert UI
      setCatchesisSliderData((prevData) => ({
        ...prevData,
        items: prevData.items.map(item =>
          item.id === id ? { ...item, favorite: !item.favorite } : item
        ),
      }));
    }
  };
  useEffect(() => {
    const loadPlayList = async () => {
      try {
        setLoadingPlayList(true);
        const today = new Date();
        const date = today.toISOString().split("T")[0];
        const response = await fetchDevotions(2, { date });

        const sortedItems = [...response.data].sort((a, b) => {
          const aTime = a.attributes?.title?.toLowerCase().includes("morning") ? 0 : 1;
          const bTime = b.attributes?.title?.toLowerCase().includes("morning") ? 0 : 1;
          return aTime - bTime;
        });

        setPlayListItems(sortedItems);
      } catch (error) {
        console.error("Error loading devotions:", error);
      } finally {
        setLoadingPlayList(false);
      }
    };

    loadPlayList();
  }, []);

  const handleToggleFavoriteDevotion = async (id) => {
    const itemIndex = playListItems.findIndex(item => item.id === id);
    if (itemIndex === -1) return;
    const originalItem = playListItems[itemIndex];
    const currentFavorite = originalItem?.attributes?.favorite ?? false;

    try {
      // Optimistically update UI
      const updatedItems = playListItems.map(item =>
        item.id === id
          ? {
            ...item,
            attributes: {
              ...item.attributes,
              favorite: !item.attributes.favorite,
            },
          }
          : item
      );
      setPlayListItems(updatedItems);

      await toggleFavorite("devotions", id, false, currentFavorite);

      if (!currentFavorite) {
        const exists = recentFavorites.find(fav => fav.id === id);
        if (!exists) {
          setRecentFavorites(prev => [{ ...originalItem, title: originalItem.attributes?.title || "Untitled Favorite" }, ...prev.slice(0, 4)]);
        }
      } else {
        setRecentFavorites(prev => prev.filter(fav => fav.id !== id));
      }
    } catch (error) {
      console.error("Failed to update favorite:", error);

      // Revert UI
      setPlayListItems(prev =>
        prev.map(item =>
          item.id === id
            ? {
              ...item,
              attributes: {
                ...item.attributes,
                favorite: !item.attributes.favorite,
              },
            }
            : item
        )
      );
    }
  };
  useEffect(() => {
    const loadEvents = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetchLiturgicalEvents();

        // Ensure response is an array and has items
        const eventsData = Array.isArray(response) ? response :
          (response.data && Array.isArray(response.data) ? response.data : []);

        if (eventsData.length > 0) {
          const transformedEvents = eventsData.map(event => {
            // Safely extract title and date
            const title = event.attributes?.title || event.title || 'Unnamed Event';
            const eventDate = event.attributes?.updated_at || event.updated_at ||
              event.attributes?.created_at || event.created_at ||
              new Date().toISOString();

            // Determine event category class
            const categoryClass = determineCategoryClass(title);

            return {
              title: title.replace('&#038;', '&'),
              date: eventDate.includes('T')
                ? eventDate
                : `${eventDate.split(' ')[0]}T00:00:00`,
              classNames: categoryClass
            };
          });

          setApiEvents(transformedEvents);
        } else {
          console.warn('No event data received from API');
          setApiEvents([]);
        }
      } catch (err) {
        console.error('Error loading events:', err);
        setError(err.message);
        setApiEvents([]);
      } finally {
        setLoading(false);
      }
    };

    loadEvents();
  }, []);

  const today = new Date();

  const { isDataLoading, eventData } = useLiturgicalEvents(
    selectedDate.getFullYear(),
    selectedDate.getMonth() + 1,
    selectedDate.getDate()
  );


  useEffect(() => {
    if (!isDataLoading && eventData) {
      setIsLoading(false); // Hide skeleton only when API data is fully loaded
    }
  }, [isDataLoading, eventData]);

  const firstEventKey = eventData ? Object.keys(eventData)[0] : null;
  const firstEvent = firstEventKey ? eventData[firstEventKey] : null;
  const disciplines = firstEvent?.disciplines || [];

  const dayData = isDataLoading
    ? {} //Show skeleton while loading (NO STATIC DATA)
    : {
      date: firstEvent?.date
        ? new Date(firstEvent.date * 1000).toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        })
        : "",
      title: firstEvent?.name
        ? firstEvent.name.replace(/\s*\/\/\s*/g, "  ")
        : "",
      tag: firstEvent?.liturgicalSeasonLcl || "",
      label: firstEvent ? "Today" : "",
      category: "Easter",
      description: firstEvent?.eventData?.description || '',
    };

  const handleDateClick = (info) => {
    setIsCalendarLoading(true);
    setSelectedDate(new Date(info.dateStr));
    setTimeout(() => setIsCalendarLoading(false), 500);
  };

  const renderDayCellClassNames = useCallback((arg) => {
    const today = new Date();
    const todayStr = today.toDateString();
    const selectedStr = selectedDate.toDateString();
    const argStr = arg.date.toDateString();

    if (argStr === selectedStr) return ['fc-day-today'];
    if (argStr === todayStr && argStr !== selectedStr) return ['fc-day-today-not-selected']; 
    return [];
  }, [selectedDate]);


  const determineCategoryClass = (title) => {
    const lowerTitle = title.toLowerCase();

    if (lowerTitle.includes('martyr')) return ['bda-fast-event'];
    if (lowerTitle.includes('apostle')) return ['bda-feast-event'];
    if (lowerTitle.includes('bishop')) return ['bda-abstinence-event'];
    if (lowerTitle.includes('virgin')) return ['bda-feast-event'];
    if (lowerTitle.includes('confessor')) return ['bda-feast-event'];
    if (lowerTitle.includes('pope')) return ['bda-feast-event'];
    if (lowerTitle.includes('presentation')) return ['bda-feast-event'];

    return ['bda-normal-event'];
  };

  const getEventIcon = (classNames) => {
    const classString = (Array.isArray(classNames) ? classNames : [classNames])
      .join(' ')
      .toLowerCase();

    if (classString.includes('fast')) {
      return <span className="inline-block w-2.5 h-2.5 rounded-full bg-[#610F7F]"></span>;
    } else if (classString.includes('feast')) {
      return <span className="inline-block w-2.5 h-2.5 rounded-full bg-[#1A856B]"></span>;
    } else if (classString.includes('abstinence')) {
      return <span className="inline-block w-2.5 h-2.5 rounded-full bg-[#E84A5A]"></span>;
    } else {
      return <span className="inline-block w-2.5 h-2.5 rounded-full bg-[#876B2E]"></span>;
    }
  };
  const handleEventClick = (info) => {
    console.log(`Event Title: ${info.event.title}`);
    setIsAccordionVisible(prevState => !prevState);
  };

  const filteredEvents = useCallback(() => {
    const allEvents = [...staticEvents, ...apiEvents];

    if (activeTab === "All") return allEvents;

    return allEvents.filter(event => {
      // Safely handle events with potential undefined properties
      const title = (event.title || '').toLowerCase();
      const classNames = event.classNames || [];

      // Check if any class matches the active tab
      const tabLower = activeTab.toLowerCase();
      return classNames.some(cn => cn.includes(tabLower)) ||
        (tabLower === 'feast' && (
          title.includes('virgin') ||
          title.includes('feast') ||
          title.includes('sunday') ||
          title.includes('easter') ||
          title.includes('pentecost')
        )) ||
        (tabLower === 'fast' && (
          title.includes('martyr') ||
          title.includes('fast') ||
          title.includes('good friday')
        )) ||
        (tabLower === 'abstinence' && (
          title.includes('bishop') ||
          title.includes('abstinence') ||
          title.includes('friday') ||
          title.includes('lent')
        ));
    });
  }, [activeTab, apiEvents, staticEvents]);

  const renderEventContent = (eventInfo) => {
    console.log('Event Info:', eventInfo);

    // Ensure we have class names
    const classNames = eventInfo.event.classNames
      ? eventInfo.event.classNames
      : ['bda-normal-event'];

    const icon = getEventIcon(classNames);

    return (
      <div className="flex items-center justify-center bda-calendar-event">
        <div className="flex flex-col items-center justify-center">
          {/* <span className="mb-1 text-xs text-center text-gold-500">
                      {eventInfo.event.title}
                  </span> */}
          <div className="w-5 h-5 ml-4">
            {icon}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="w-full bg-white-50">
      <div className='flex flex-col w-full lg:flex-row'>
        <div className='w-full lg:max-w-[40%] max-w-100%  lg:border-r border-b lg:border-b-0 border-gray-100'>
          <div className='flex flex-row justify-between px-4 pt-8 md:px-12'>
            <a href='#' className="flex flex-row items-center gap-3 group">
              <div className="flex items-center justify-center rounded-full bg-gold-50 md:h-11 md:w-11 h-9 w-9">
                <Link to='/calendar'>
                  <LeftArrowIcon className="text-gray-700 group-hover:text-gold-500" />
                </Link>
              </div>
              <h5 className="font-normal text-base leading-5.5 text-gray-600 ml-3 group-hover:text-gold-500">

                <Link to='/calendar'>
                  Back to calendar
                </Link>
              </h5>
            </a>
            <div className="flex justify-end gap-2 lg:hidden">
              {/* <a href="#" className="flex items-center justify-center rounded-full bg-gold-50 md:h-11 md:w-11 h-9 w-9 group">
                  <HeartIcon className="w-6 h-6 text-gray-700 group-hover:text-gold-500" />
                </a> */}
              <button
                onClick={handleToggleSingleFavorite}
                disabled={isFavoriteLoading}
                className="focus:outline-none"
                title={singleData?.favorite ? "Remove from Favorites" : "Add to Favorites"}
              >
                <FavoritesIcon
                  filled={Boolean(singleData?.favorite)}
                  className={`w-7 h-7 transition-colors duration-200 ${singleData?.favorite
                    ? "text-red-500"
                    : "text-gray-500 hover:text-red-500"
                    } ${isFavoriteLoading ? "opacity-50 cursor-not-allowed" : ""}`}
                />
              </button>

              <a href="#" className="flex items-center justify-center rounded-full bg-gold-50 md:h-11 md:w-11 h-9 w-9 group">
                <LinkIcon className="text-gray-700 group-hover:text-gold-500" />
              </a>
            </div>
          </div>
          <div className='px-4 pb-8 border-b border-gray-100 md:px-12 pt-8'>
            <DayBar {...dayData} disciplines={disciplines} isLoading={isLoading} />
          </div>
          <div className='px-4 md:px-12'>
            <div className="py-8 bda-full-calendar bda-compact-calendar bda-week-calendar">
              <FullCalendar
              key={selectedDate.toDateString()}
                ref={calendarRef}
                plugins={[dayGridPlugin , interactionPlugin]}
                initialView='dayGridWeek'
                initialDate={selectedDate}
                weekends={true}
                events={loading ? [] : filteredEvents()}
                eventContent={renderEventContent}
                dayHeaderContent={renderWeekDayHeaderContent}
                dayCellContent={renderWeekDayBodyContent}
                eventDisplay='block'
                default={false}
                dayMaxEvents={true}
                views={views}
                eventClick={handleEventClick}
                headerToolbar={{
                  left: 'title',
                  center: '',
                  right: 'prev,next',
                }}
                height="auto"
                contentHeight="auto"
                // dateClick={(info) => {
                //   setSelectedDate(new Date(info.dateStr));
                // }}
                dateClick={handleDateClick}
                dayCellClassNames={renderDayCellClassNames}

              />
            </div>
            <div className='flex justify-between pb-8'>
              <div onClick={() => setSelectedDate(prev => {
                const newDate = new Date(prev);
                newDate.setDate(newDate.getDate() - 1);
                return newDate;
              })} >
                <p className="cursor-pointer text-base font-normal text-gray-600">Previous Post</p>
                <h5 className="cursor-pointer text-xl font-bold leading-6.5 text-gray-900 underline font-cmr"

                >{prevDayData.title}</h5>
              </div>
              <div onClick={() => setSelectedDate(prev => {
                const newDate = new Date(prev);
                newDate.setDate(newDate.getDate() + 1);
                return newDate;
              })} >
                <p className="cursor-pointer text-base font-normal text-gray-600">Next Post</p>
                <h5 className="cursor-pointer text-xl font-bold leading-6.5 text-gray-900 underline font-cmr"

                >{nextDayData.title}</h5>
              </div>
            </div>
          </div>
        </div>
        <div className='w-full lg:max-w-[60%] max-w-100%'>
          <div className='px-4 pb-8 md:px-12'>
            <div className="justify-end hidden gap-2 mt-8 lg:flex">
              {/* <a href="#" className="flex items-center justify-center rounded-full bg-gold-50 md:h-11 md:w-11 h-9 w-9 group">
                <HeartIcon className="w-6 h-6 text-gray-700 group-hover:text-gold-500" />
              </a> */}
              <a
                href="#"
                className="flex items-center justify-center rounded-full bg-gold-50 h-11 w-11 group"
                onClick={(e) => {
                  e.preventDefault(); // Prevent navigation
                  copyToClipboard();
                }}
              >
                <LinkIcon className={`text-gray-700 w-7 h-7 group-hover:text-gold-500 ${copied ? "text-green-500 group-hover:text-green-500" : ""}`} />
              </a>
            </div>
            <section className="pt-8 overflow-hidden rounded-lg md:pt-6 bg-white-50">
              <PlayList
                title="Today in Benedictus"
                items={playListItems}
                loading={loadingPlayList}
                onToggleFavorite={handleToggleFavoriteDevotion}
              />

              <PlayList
                title="Alternate meditations for Today"
                columns={2}
                dayData={dayData}
                items={playListItems}
                loading={loadingPlayList}
                onToggleFavorite={handleToggleFavoriteDevotion}
              />
              {cultureSliderData.items.length > 0 && (
                <section>
                  {cultureSliderData.items.length > 0 && (
                    <CultureCustomsSlider
                      data={cultureSliderData}
                      isLoading={loadingCulture}
                      onToggleFavorite={handleToggleFavoriteCulture}
                    />
                  )}
                </section>
              )}
            </section>
            <section>
              {catchesisSliderData.items.length > 0 && (
                <CatechesisSlider
                  data={catchesisSliderData}
                  isLoading={loadingCulture}
                  onToggleFavorite={handleToggleFavoriteCatchesis}
                />
              )}
            </section>
            <section className='mt-6'>
              {prayersData.items.length > 0 && (
                <PrayersList
                  data={prayersData}
                  isLoading={loadingCulture}
                  onToggleFavorite={handleToggleFavorite}
                />
              )}

            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
// a custom render function
function renderEventContent(eventInfo) {
  return (
    <>
      <div className='bda-calendar-event'>
        <div className='flex flex-col items-center justify-center bda-calendar-single-event current-date'>
          <span className='mb-1 text-xs font-medium leading-4 text-gold-500'>{eventInfo.event.title}</span>
          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.15295 9.11719L9.15297 9.11718C9.96712 8.499 11.0367 7.84375 11.5065 7.65602C13.3645 6.91382 15.8873 7.19081 17.7751 8.38235C18.6118 8.91052 19.5051 9.75224 20.1889 10.5969C20.5295 11.0177 20.8086 11.4277 21 11.787C21.1815 12.1278 21.2588 12.3766 21.2712 12.5273C21.26 12.5541 21.2408 12.5942 21.2107 12.6488C21.1431 12.7711 21.0388 12.9333 20.9015 13.1261C20.6281 13.51 20.2457 13.9843 19.8219 14.4519L19.8218 14.4521C18.1733 16.2725 16.2832 17.141 14.6038 17.1543C13.8639 17.1601 12.7607 17.0072 11.674 16.6907C10.5776 16.3715 9.5732 15.9073 8.97478 15.3367L8.95481 15.3177C8.68921 15.0644 8.45984 14.8456 8.25543 14.6907C8.03961 14.527 7.79556 14.3895 7.49554 14.3677C7.20256 14.3464 6.93514 14.4417 6.68577 14.5639C6.44276 14.683 6.15415 14.8605 5.81022 15.0722L5.78908 15.0852L5.789 15.0852C5.41328 15.3165 4.99728 15.5273 4.63415 15.6787C4.45264 15.7544 4.29038 15.8127 4.15741 15.8513C4.01528 15.8926 3.93847 15.9018 3.91541 15.9018C3.84103 15.9018 3.82686 15.8823 3.81658 15.8681C3.81625 15.8676 3.81593 15.8672 3.8156 15.8667C3.78929 15.8308 3.74546 15.7319 3.74619 15.5332C3.74763 15.1376 3.92786 14.5396 4.34315 13.9088L4.34326 13.9086C4.6554 13.4341 4.91234 13.0222 4.91234 12.5136C4.91234 12.2639 4.85172 12.0224 4.76036 11.7719C4.66989 11.5239 4.53822 11.2387 4.37649 10.9009L4.37639 10.9007C4.19322 10.5186 4.02639 10.1041 3.90638 9.74775C3.84638 9.56959 3.79979 9.41106 3.76877 9.28193C3.73562 9.14396 3.72754 9.06879 3.72754 9.04497C3.72754 9.026 3.72952 9.01491 3.73088 9.00959C3.73175 9.00895 3.73289 9.00815 3.73433 9.0072C3.76223 8.98887 3.8585 8.94895 4.06854 8.95627C4.48292 8.97071 5.11936 9.16235 5.84857 9.57897L5.84858 9.57898C6.14655 9.7492 6.41182 9.89905 6.65155 9.99452C6.90584 10.0958 7.16707 10.1514 7.45805 10.1064C7.73481 10.0635 7.98754 9.93696 8.24049 9.77651C8.4933 9.61615 8.79046 9.3924 9.15295 9.11719ZM21.281 12.5005C21.2811 12.5005 21.2807 12.502 21.2797 12.505C21.2805 12.5021 21.281 12.5005 21.281 12.5005ZM3.73213 9.00568C3.73214 9.00569 3.73205 9.00593 3.73183 9.00639L3.73213 9.00568Z" stroke="#876B2E" />
            <circle cx="16.8634" cy="12.1998" r="0.590909" stroke="#876B2E" />
          </svg>
        </div>
        <div className='bda-calendar-single-event abstinence-event'>
          <i className='icon-event icon-event-abstinence'>
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M8.68724 5.44377C8.28799 5.60332 7.45407 6.11876 6.83449 6.58921C5.73282 7.42563 5.68667 7.43287 4.76899 6.90861C3.61675 6.2503 2.61719 6.21537 2.61719 6.83372C2.61719 7.08735 2.85269 7.78688 3.14068 8.38761C3.62749 9.40434 3.62749 9.53524 3.14068 10.2754C2.4645 11.3025 2.46071 12.3513 3.13309 12.3513C3.41696 12.3513 4.1377 12.0508 4.73485 11.6833C5.8207 11.0152 5.8207 11.0152 6.66884 11.8239C7.6959 12.8032 9.95613 13.3001 11.1523 13.2907C12.5397 13.2797 14.0511 12.565 15.3408 11.1407C15.993 10.4211 16.5263 9.67213 16.5263 9.47671C16.5263 8.66704 15.068 6.8655 13.728 6.01964C12.2214 5.06867 10.2036 4.83801 8.68724 5.44377ZM13.263 9.07896C13.3651 9.82921 12.4168 9.98655 12.1007 9.67187C11.9426 9.51453 11.7845 9.19985 11.9426 8.88517C12.2113 8.35014 13.049 8.41315 13.263 9.07896Z" fill="#E84A5A" />
            </svg>
          </i>
        </div>
        <div className='bda-calendar-single-event fast-event'>
          <i className='icon-event icon-event-fast'>
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.42297 7.18739L7.42298 7.18738C8.03057 6.72604 8.82211 6.24263 9.15886 6.10805C10.5114 5.56775 12.3617 5.76784 13.7473 6.64241C14.3607 7.0296 15.0208 7.65071 15.5271 8.27628C15.7791 8.58751 15.9835 8.88834 16.1223 9.14892C16.2427 9.37486 16.2934 9.5333 16.3078 9.62539C16.3013 9.63882 16.2925 9.65566 16.2812 9.67612C16.2337 9.76211 16.1585 9.87948 16.057 10.022C15.8552 10.3053 15.5715 10.6573 15.2565 11.005L15.2564 11.0051C14.0377 12.3508 12.6515 12.981 11.4345 12.9907C10.894 12.9949 10.0788 12.8826 9.27308 12.648C8.45767 12.4105 7.72727 12.0694 7.30002 11.662C7.30002 11.662 7.30001 11.662 7.30001 11.662L7.28132 11.6442C7.08538 11.4573 6.90882 11.2889 6.74976 11.1683C6.57935 11.0391 6.37311 10.9199 6.11339 10.9011C5.8607 10.8827 5.63605 10.9655 5.442 11.0606C5.25424 11.1526 5.03331 11.2885 4.77897 11.445L4.75897 11.4573L4.75889 11.4574C4.4827 11.6274 4.17652 11.7825 3.91017 11.8936C3.77704 11.9491 3.6599 11.9911 3.56587 12.0184C3.49767 12.0382 3.4553 12.0462 3.43458 12.0493C3.42656 12.0231 3.41703 11.976 3.41731 11.9003C3.41827 11.6349 3.54184 11.2099 3.84443 10.7503L3.84454 10.7501C4.07555 10.3989 4.29192 10.0597 4.29192 9.63517C4.29192 9.42752 4.24144 9.23087 4.17037 9.03602C4.10018 8.84362 3.99894 8.62467 3.87778 8.37163L3.87768 8.37142C3.7425 8.08944 3.6193 7.78326 3.53092 7.52085C3.48672 7.38964 3.45295 7.27444 3.43079 7.18219C3.42279 7.14891 3.41673 7.12035 3.41231 7.09644C3.44013 7.09276 3.47853 7.09028 3.52972 7.09206C3.8128 7.10193 4.26992 7.2358 4.80708 7.5427L4.8071 7.54271C5.02859 7.66924 5.23554 7.78648 5.42508 7.86196C5.62917 7.94325 5.84833 7.99144 6.09531 7.95324C6.32808 7.91723 6.5349 7.81162 6.72999 7.68788C6.92494 7.56422 7.15229 7.3929 7.42297 7.18739ZM16.325 9.58558C16.3251 9.58551 16.3246 9.58732 16.3231 9.59117C16.3242 9.58757 16.3249 9.58565 16.325 9.58558Z" stroke="#610F7F" />
              <circle cx="13.1297" cy="9.39985" r="0.818182" fill="#610F7F" />
            </svg>
          </i>
        </div>
        <div className='bda-calendar-single-event feast-event'>
          <i className='icon-event icon-event-feast'>
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.81896 3.59267C7.68421 3.72552 7.68362 3.99038 7.68362 4.12323C7.68362 4.30982 7.60192 4.36477 7.32483 4.36477C6.94693 4.36477 6.58115 4.5172 6.58115 4.90823C6.58115 5.24247 6.79833 5.38752 7.32483 5.45169C7.64932 5.45169 7.68362 5.48997 7.68362 5.85168C7.68362 6.15481 7.59591 6.31555 7.32103 6.51591C7.12173 6.66119 6.97261 6.72226 6.86167 6.78232C6.64426 6.90004 5.74327 7.42011 5.32777 7.76804C4.99298 8.04823 4.99298 8.04823 4.9909 10.8609C4.9887 13.6738 4.9887 13.6738 5.99929 13.6386C7.00989 13.6036 7.00989 13.6036 7.07114 12.3549C7.1292 11.1705 7.15015 11.091 7.47611 10.815C7.93499 10.4264 8.59965 10.4264 9.09233 10.815C9.44892 11.0963 9.46166 11.142 9.52107 12.3543C9.58232 13.6036 9.58232 13.6036 10.5929 13.6386C11.6035 13.6738 11.6035 13.6738 11.6035 10.8519C11.6035 7.64256 11.6883 7.90898 10.4398 7.19427C10.1029 7.0014 9.71707 6.77713 9.58232 6.69585C9.44757 6.6147 9.21324 6.48294 9.06171 6.40323C8.8602 6.29732 8.78609 6.14974 8.78609 5.85494C8.78609 5.46449 8.78609 5.38752 9.28327 5.38752C9.68723 5.38752 9.94105 5.24247 9.94105 4.87983C9.94105 4.44467 9.42945 4.36773 9.18421 4.36658C8.82505 4.36489 8.78609 4.32974 8.78609 4.00669C8.78609 3.77626 8.74091 3.63127 8.55241 3.50182C8.25092 3.26896 8.18645 3.29077 7.81896 3.59267ZM3.17759 9.38893C2.57393 9.70703 2.03493 10.1364 1.93118 10.2907C1.78884 10.5023 1.74609 10.8794 1.75699 11.8265C1.77622 13.5051 1.86564 13.6036 3.3688 13.6036C4.43746 13.6036 4.43746 13.6036 4.4709 11.3178C4.48928 10.0606 4.65471 9.07162 4.40965 8.94264C4.1646 8.81367 3.78126 9.07082 3.17759 9.38893ZM12.216 11.2592C12.216 13.6888 12.216 13.6888 13.2679 13.6462C14.2431 13.6067 14.3412 13.579 14.6153 13.2647C14.8847 12.9559 14.9109 12.8199 14.9109 11.7317C14.9109 10.2814 14.8542 10.1995 13.2878 9.38623C12.216 8.82972 12.216 8.82972 12.216 11.2592Z" fill="#1A856B" />
            </svg>
          </i>
        </div>
      </div>
    </>
  )
}
// Custom render for day headers
function renderWeekDayHeaderContent(date) {
  const dayName = date.text.split(' ')[0];
  return (
    <div className="custom-day-header">
      <div className="day-name">{dayName}</div>
    </div>
  );
}
// Custom render for day contents
function renderWeekDayBodyContent(date) {
  const dayDate = date.date.getDate();
  return (
    <div className="custom-day-header">
      <div className="day-date">{dayDate}</div>
    </div>
  );
}
export default SingleDay;